
import { Vue, Component, Ref, Watch, Prop } from 'vue-property-decorator';
import SPUcar from '@/components/carModule/SPUcar.vue';
import { CarFieldFactory } from '@/models/carFieldFactory';
import lazyInject from '@/di';
import CarService from '@/services/car.service';
import { JCarSPU, CarSPU } from '@/models/car.model';


@Component({
  components: {
    SPUcar,
  },
})
export default class carTableList extends Vue {
  @Ref()
  spuCar!: SPUcar;

  @Prop()
  shopId!: any;

  @lazyInject(CarService)
  CarService!: CarService;

  classifyKey = -1;

  selectedCategoryId = -1;

  size = 'small';

  pagination = {
    total: 0,
    current: 1,
    pageSize: 10,
    onChange: this.pageChange,
  };


  columns = [
    {
      dataIndex: 'commodity_code',
      title: '商品编码',
      key: 'commodity_code',
      align: 'center',
      width: 150,
    },
    {
      title: '车辆图片',
      dataIndex: 'header_image',
      key: 'header_image',
      align: 'center',
      scopedSlots: { customRender: 'header_image' },
    },
    {
      title: '品牌',
      dataIndex: 'series',
      key: 'series',
      align: 'center',
      width: 240,
    },
    {
      title: '车系',
      key: 'model_name',
      dataIndex: 'model_name',
      align: 'center',
      width: 240,
    },
    {
      title: '所在地',
      key: 'car_location',
      dataIndex: 'car_location',
      align: 'center',
      width: 100,
    },
    {
      title: '排量',
      key: 'liter',
      dataIndex: 'liter',
      align: 'center',
      width: 100,

    },
    {
      title: '变速箱',
      key: 'gear_name',
      dataIndex: 'gear_name',
      align: 'center',
      width: 140,

    },
    {
      title: '首次上牌',
      key: 'first_registration_date',
      dataIndex: 'first_registration_date',
      align: 'center',
      width: 140,

    },
    {
      title: '表显里程',
      key: 'mileage',
      dataIndex: 'mileage',
      align: 'center',
      width: 120,
      customRender: (text: any) => {
        if (text) {
          return `${text}万公里`;
        }
        return '--';
      },
    },
    {
      title: '车辆售价',
      key: 'price',
      dataIndex: 'price',
      align: 'center',
      width: 120,
      customRender: (text: any) => {
        if (text) {
          return `${text}万`;
        }
        return '--';
      },
    },
    {
      title: '车辆新车价格',
      key: 'official_price',
      dataIndex: 'official_price',
      align: 'center',
      width: 120,
      customRender: (text: any) => {
        if (text) {
          return `${text}万`;
        }
        return '--';
      },
    },
    {
      title: '创建时间',
      key: 'created_at',
      dataIndex: 'created_at',
      align: 'center',
      width: 140,

    },
    {
      title: '修改时间',
      key: 'updated_at',
      dataIndex: 'updated_at',
      align: 'center',
      width: 140,
    },
    {
      title: '状态',
      key: 'online_str',
      dataIndex: 'online_str',
      align: 'center',
      width: 100,
    },
    {
      title: '操作',
      key: 'action',
      align: 'center',
      fixed: 'right',
      width: 180,
      scopedSlots: { customRender: 'action' },
    },
  ];

  commodityCode = '';


  dataSource = [];

  classifyData = [];
  secondCategoryList = [];

  allList = [];

  formData: any = {
    pid: '',
    cid: '',
  };

  pid: any = '';


  @Watch('classifyKey')
  onClassifyKeyChange() {
    this.selectedCategoryId = -1;
    this.formData.cid = '';
    if (this.classifyKey === -1) {
      this.secondCategoryList = this.allList.filter((item: any) => item.c_level === 2);
      this.formData.pid = '';

      this.getlist(this.pagination, this.formData);
    } else {
      this.secondCategoryList = this.allList.filter((item: any) => item.pid === this.classifyKey);
      this.formData.pid = this.classifyKey;

      this.getlist(this.pagination, this.formData);
    }
  }

  open() {
    const carFields = CarFieldFactory.init({ spuType: 'car' });
    // console.log(carFields);
    this.spuCar.open();
    const form = new CarSPU();
    this.spuCar.setup(carFields, form);
  }

  async editor(val: any) {
    // console.log(val);
    const p = {
      code: val.commodity_code,
    };
    this.commodityCode = val.commodity_code;
    const res = await this.CarService.getCarCommodityDetail(p);
    const carFields = CarFieldFactory.init({ spuType: 'car' });
    this.spuCar.open();
    const form = CarSPU.form(res);
    // console.log(form);
    this.spuCar.setup(carFields, form);
  }

  async spuPush(val: any) {
    const _d = {
      code: val.commodity_code,
      type: val.online === 1 ? 'offline' : 'online',
    };
    const res = await this.CarService.getCarCommodityPush(_d);
    if (res) {
      this.$message.success(res);
      this.getlist(this.pagination, this.formData);
    }
  }


  pageChange(page: number, pageSize: number) {
    // console.log(page, pageSize);
    this.pagination.current = page;
    this.pagination.pageSize = pageSize;
    this.getlist(this.pagination, this.formData);
  }


  async deleteSpu(val: any) {
    const _d = {
      code: val.commodity_code,
    };
    const res = await this.CarService.getCarCommodityDelete(_d);
    if (res) {
      this.$message.success('操作成功');
      this.getlist(this.pagination, this.formData);
    }
  }

  cancel() { }

  async CopySPUModal(val: any) {
    const p = {
      code: val.commodity_code,
    };
    this.commodityCode = val.commodity_code;
    const res = await this.CarService.getCarCommodityDetail(p);
    const carFields = CarFieldFactory.init({ spuType: 'car' });
    this.spuCar.open();
    const form = CarSPU.form(res);
    form.id = 0;
    this.spuCar.setup(carFields, form);
  }

  async addCarCommodity(form: any) {
    const r = JCarSPU.form(form);
    r.shop_id = Number(this.shopId);
    // console.log(r);
    if (r.id === 0) {
      const res = await this.CarService.addCarCommodity(r);
      if (res) {
        this.$message.success('添加成功');
        this.spuCar.onClose();
        this.getlist(this.pagination, this.formData);
      }
    } else {
      r.commodity_code = this.commodityCode;
      const res = await this.CarService.updateCarCommodity(r);
      if (res) {
        this.$message.success('编辑成功');
        this.commodityCode = '';
        this.spuCar.onClose();
        this.getlist(this.pagination, this.formData);
      }
    }
  }
  initval: any = '';
  init(val: any) {
    this.initval = val;
    this.getlist(this.pagination, this.formData);
  }

  async getlist(val: any, data: any) {
    const params = {
      shop_id: this.shopId,
      page: val.current,
      pageSize: val.pageSize,
      pid: data.pid,
      cid: data.cid,
    };
    const res = await this.CarService.getCarCommodityList(params, this.$el);
    if (res) {
      this.dataSource = res.list;
      this.pagination.total = res.total;
    } else {
      this.dataSource = [];
      this.pagination.total = 0;
    }
  }

  mounted() {
    this.getCarConfig();
    this.getCarCategoryList();
  }

  /**
 * 车源配置
 */
  async getCarConfig() {
    const res = await this.CarService.getCarConfig();
    localStorage.setItem('carFields', JSON.stringify(res));
  }


  catrgorySelect(id: number) {
    this.selectedCategoryId = id;
    let cid: any = id;
    this.formData.cid = cid;

    if (id === -1) {
      cid = this.classifyKey === -1 ? this.classifyKey : '';
      this.formData.cid = '';
    }
    this.getlist(this.pagination, this.formData);
  }

  async getCarCategoryList() {
    const res = await this.CarService.getCarCategoryList();
    this.classifyData = res.filter((item: any) => item.c_level === 1);
    this.secondCategoryList = res.filter((item: any) => item.c_level === 2);
    this.allList = res;
  }
}
